import * as React from "react";
import SDK from "./sdk";

export const SDKContext = React.createContext<{
  sdk: InstanceType<typeof SDK>;
}>({
  sdk: new SDK({ baseUrl: "" }),
});
